import React ,{ useEffect} from "react";
import * as s from "./Documents.styles";

// components
import DocumentsControls from "./documentsControls/DocumentsControls";
import Spinner from "../../../shared/spinner/Spinner";
//reducers
import * as actions from "../../../../store/actions/index";
import { useDispatch , useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";

const Documents = () => {

let { clientId } = useParams();
// console.log(clientId);
const history = useHistory();
let dispatch = useDispatch();
useEffect(() => {
  dispatch(actions.fetchFoldersUserAdmin(clientId ,1,10));
}, []);

const folderLoading = useSelector((state) => state.forClientFolders.loading);

const folders = useSelector((state) => state.forClientFolders.folders);
console.log(folders);


  return (
    <s.Wrapper>
        <s.H1>Documents</s.H1>
       {folderLoading === false ? (
          <s.DocumentsContainer>
        
          <DocumentsControls foldersData ={folders} /> 
         
       </s.DocumentsContainer>

       ):(
        <s.SpinnerContainer>
        <Spinner />
      </s.SpinnerContainer>

       )}
         

      
      <s.btnContainer>
      <s.CreateBtn 
       onClick={() =>
        history.push(`/clients/${clientId}/folder-profile`)
      }>
             Create Folder
        </s.CreateBtn>
      </s.btnContainer>
      
    </s.Wrapper>
  );
};

export default Documents;
